const ENCODINGS_TO_TRY = ['windows-1252'];
function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
    });
}
function tryDecode(bytes, encoding) {
    try {
        const decoder = new TextDecoder(encoding, { fatal: true });
        return decoder.decode(bytes);
    }
    catch {
        return null;
    }
}
function detectUtf16Bom(bytes) {
    if (bytes.length >= 2) {
        if (bytes[0] === 0xfe && bytes[1] === 0xff) {
            return 'utf-16be';
        }
        if (bytes[0] === 0xff && bytes[1] === 0xfe) {
            return 'utf-16le';
        }
    }
    return null;
}
function guessBomlessUtf16(bytes) {
    if (bytes.length < 2) {
        return null;
    }
    if (bytes[0] !== 0x00 && bytes[0] < 0x80 && bytes[1] === 0x00) {
        return 'utf-16le';
    }
    if (bytes[0] === 0x00 && bytes[1] !== 0x00 && bytes[1] < 0x80) {
        return 'utf-16be';
    }
    return null;
}
function isValidUtf8(bytes) {
    return tryDecode(bytes, 'utf-8') !== null;
}
function toUtf8File(text, fileName) {
    const utf8Bytes = new TextEncoder().encode(text);
    const blob = new Blob([utf8Bytes], { type: 'text/csv;charset=utf-8' });
    return new File([blob], fileName, { type: 'text/csv;charset=utf-8' });
}
export async function convertCsvToUtf8(file) {
    const arrayBuffer = await readFileAsArrayBuffer(file);
    const uint8Array = new Uint8Array(arrayBuffer);
    const bomEncoding = detectUtf16Bom(uint8Array);
    if (bomEncoding !== null) {
        const decoded = tryDecode(uint8Array, bomEncoding);
        if (decoded !== null) {
            return toUtf8File(decoded, file.name);
        }
    }
    const guessedUtf16 = guessBomlessUtf16(uint8Array);
    if (guessedUtf16 !== null) {
        const decoded = tryDecode(uint8Array, guessedUtf16);
        if (decoded !== null) {
            return toUtf8File(decoded, file.name);
        }
    }
    if (isValidUtf8(uint8Array)) {
        return file;
    }
    const decodedText = ENCODINGS_TO_TRY.map(encoding => tryDecode(uint8Array, encoding)).find((text) => text !== null);
    if (decodedText !== undefined) {
        console.warn(`CSV encoding not recognized (${file.name}). ` +
            'Falling back to windows-1252; content may be garbled. ' +
            'Please ensure the file is UTF-8 encoded.');
        return toUtf8File(decodedText, file.name);
    }
    return file;
}
//# sourceMappingURL=csv-encoding.util.js.map